WiseMetering.Collection.ScheduledReports = WiseMetering.Collection.extend({
    hasOrganization: true,
    model: WiseMetering.Model.ScheduledReport,
    url: '/scheduled_reports'
});
